<p-toast></p-toast>
<p-dialog
  [header]="'i18n.domain.deliveryDetails.dialogs.create-delivery-plan' | translate"
  [(visible)]="showPlanConfirmation"
  [modal]="true"
  [style]="{ width: '28rem' }"
>
  <p>{{ selectedOrderCount }} {{ "i18n.domain.deliveryDetails.labels.orders-selected" | translate }}</p>
  <p>{{ confirmationDestinationCount }} {{ "i18n.domain.deliveryDetails.labels.destinations" | translate }}</p>
  <p>{{ "i18n.domain.deliveryDetails.labels.shop" | translate }}: {{ selectedShopName }}</p>
  <p>{{ "i18n.domain.deliveryDetails.messages.no-route-estimate" | translate }}</p>
  <label>{{ "i18n.domain.deliveryDetails.fields.delivery-plan-name" | translate }}</label>
  <input type="text" pInputText [(ngModel)]="newDeliveryPlan.name" />
  <label>{{ "i18n.domain.deliveryDetails.fields.assigned" | translate }}</label>
  <select [(ngModel)]="newDeliveryPlan.assignedToId">
    <option value="">{{ "i18n.domain.deliveryDetails.placeholders.assign-driver" | translate }}</option>
    <option *ngFor="let user of applicationUsers" [value]="user.userId">{{ user.displayName }}</option>
  </select>
  <div class="confirmation-actions">
    <button type="button" (click)="showPlanConfirmation = false">{{ "i18n.domain.deliveryDetails.actions.cancel" | translate }}</button>
    <button type="button" (click)="confirmCreatePlan()">{{ "i18n.domain.deliveryDetails.actions.create" | translate }}</button>
  </div>
</p-dialog>

<div class="page-header">
  <h1>{{ "i18n.domain.deliveryDetails.sections.title" | translate }}</h1>
</div>

<div class="delivery-dashboard" [class.fullscreen-map]="isMapFullScreen">
  <div class="left-sidebar" *ngIf="!isMapFullScreen">
    <div class="pending-orders-section">
      <div class="section-header">
        <div class="header-left">
          <button
            class="search-toggle-btn"
            (click)="toggleSearch()"
            [class.active]="showSearch"
            title="Search orders"
          >
            <i class="pi pi-search"></i>
          </button>
          <h3>
            {{ "i18n.domain.deliveryDetails.sections.eligible-orders" | translate }}
          </h3>
        </div>
        <a
          href="#"
          class="view-all-link-header"
          (click)="viewAllOrders($event)"
        >
          {{ "i18n.domain.deliveryDetails.actions.view-all-orders" | translate }}
        </a>
      </div>

      <div class="planning-filters">
        <select class="plan-filter-select" [(ngModel)]="assignmentFilter" (ngModelChange)="reloadEligibleOrders()">
          <option value="unassigned">Unassigned</option>
          <option value="assigned">Assigned</option>
        </select>
        <select class="plan-filter-select" [(ngModel)]="shopId" (ngModelChange)="reloadEligibleOrders()">
          <option [ngValue]="null">{{ "i18n.domain.deliveryDetails.filters.all-shops" | translate }}</option>
          <option *ngFor="let shop of shops" [ngValue]="shop.id">{{ shop.name }}</option>
        </select>
        <input type="date" [(ngModel)]="fromDate" (change)="reloadEligibleOrders()" />
        <input type="date" [(ngModel)]="filterToDate" (change)="reloadEligibleOrders()" />
        <select class="plan-filter-select" [(ngModel)]="statusFilter" (ngModelChange)="reloadEligibleOrders()">
          <option [ngValue]="null">{{ "i18n.domain.deliveryDetails.filters.any-status" | translate }}</option>
          <option [ngValue]="0">Pending</option>
          <option [ngValue]="1">Processing</option>
        </select>
      </div>

      <div class="selection-bar">
        <span>{{ selectedOrderCount }} {{ "i18n.domain.deliveryDetails.labels.orders-selected" | translate }}</span>
        <button type="button" (click)="selectVisibleEligibleOrders()">{{ "i18n.domain.deliveryDetails.actions.select-page" | translate }}</button>
        <button type="button" (click)="clearOrderSelection()">{{ "i18n.domain.deliveryDetails.actions.clear-selection" | translate }}</button>
        <button type="button" (click)="openPlanConfirmation()" [disabled]="selectedOrderCount === 0">{{ "i18n.domain.deliveryDetails.actions.create-plan" | translate }}</button>
      </div>

      <div class="search-box" *ngIf="showSearch">
        <i class="pi pi-search" *ngIf="!searchQuery"></i>
        <input
          type="text"
          pInputText
          [(ngModel)]="searchQuery"
          (input)="applySearchFilter()"
          placeholder="{{
            'i18n.domain.deliveryDetails.placeholders.search-orders' | translate
          }}"
          class="search-input"
          [class.has-text]="searchQuery"
          #searchInput
        />
        <button
          class="clear-search-btn"
          *ngIf="searchQuery"
          (click)="clearSearch()"
          title="Clear search"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="orders-list">
        <div *ngIf="ordersLoading" class="no-orders">
          <p>{{ "i18n.domain.deliveryDetails.messages.loading-orders" | translate }}</p>
        </div>
        <div *ngIf="ordersLoadError" class="no-orders">
          <p>{{ ordersLoadError }}</p>
        </div>
        <div
          *ngFor="let order of filteredPendingOrders"
          class="order-item"
          [class.highlighted]="highlightedOrderId === order.id"
          [class.selected-order]="isOrderSelected(order.id)"
          (click)="onPendingOrderClick(order)"
        >
          <input
            type="checkbox"
            [checked]="isOrderSelected(order.id)"
            [disabled]="order.eligible === false"
            (click)="$event.stopPropagation()"
            (change)="toggleOrderSelection(order, $any($event.target).checked)"
          />
          <div class="order-info">
            <div class="order-name">{{ order.buyerName }}</div>
            <div class="order-address">{{ order.orderNumber }} · {{ order.deliveryAddress }}</div>
            <div class="order-datetime">
              {{ formatDateTime(order.orderDate) }}
              <span *ngIf="order.activeDeliveryPlanName"> · {{ order.activeDeliveryPlanName }}</span>
            </div>
          </div>
          <i class="pi pi-chevron-right"></i>
        </div>

        <div *ngIf="!ordersLoading && filteredPendingOrders.length === 0" class="no-orders">
          <p>
            {{
              "i18n.domain.deliveryDetails.messages.no-orders-found" | translate
            }}
          </p>
        </div>
      </div>
      <div class="page-bar">
        <button type="button" (click)="previousEligiblePage()" [disabled]="eligibleSkip === 0">{{ "i18n.domain.deliveryDetails.actions.previous" | translate }}</button>
        <span>{{ eligibleTotal === 0 ? 0 : eligibleSkip + 1 }}–{{ eligibleSkip + filteredPendingOrders.length }} / {{ eligibleTotal }}</span>
        <button type="button" (click)="nextEligiblePage()" [disabled]="eligibleSkip + eligibleTake >= eligibleTotal">{{ "i18n.domain.deliveryDetails.actions.next" | translate }}</button>
      </div>
    </div>

    <div class="open-deliveries-section">
      <div class="section-header">
        <h3>
          {{
            "i18n.domain.deliveryDetails.sections.open-deliveries" | translate
          }}
        </h3>
        <div class="section-header-actions">
          <select class="plan-filter-select" [(ngModel)]="deliveryPlanFilter">
            <option value="active">Open</option>
            <option value="completed">Completed</option>
          </select>
          <button
            pButton
            icon="pi pi-plus"
            class="p-button-text p-button-sm add-btn"
            (click)="openNewDeliveryDialog()"
            [style.visibility]="
              deliveryPlanFilter === 'active' ? 'visible' : 'hidden'
            "
          ></button>
        </div>
      </div>

      <div class="deliveries-list">
        <div
          *ngFor="let plan of filteredDeliveryPlans"
          class="delivery-item"
          [class.selected]="selectedDeliveryPlan?.id === plan.id"
          [class.delivered-item]="plan.status === 'delivered'"
          (click)="onDeliveryPlanClick(plan)"
        >
          <div class="delivery-info">
            <div class="delivery-name">{{ plan.name }}</div>
            <div class="delivery-assignee" *ngIf="plan.assignedTo">
              {{ plan.assignedTo }}
            </div>
            <div
              class="delivery-status"
              [class.delivered-status]="plan.status === 'delivered'"
            >
              {{
                plan.status === "draft"
                  ? "Draft"
                  : plan.status === "delivered"
                    ? "Delivered"
                    : "Out for Delivery"
              }}
            </div>
            <div class="delivery-orders-count">
              {{ plan.orderIds.length }}
              {{
                "i18n.domain.deliveryDetails.labels.orders-count" | translate
              }}
            </div>
          </div>
          <i class="pi pi-chevron-right"></i>
        </div>

        <div *ngIf="filteredDeliveryPlans.length === 0" class="no-deliveries">
          <p>
            {{
              deliveryPlanFilter === "active"
                ? ("i18n.domain.deliveryDetails.messages.no-delivery-plans"
                  | translate)
                : "No completed delivery plans"
            }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="right-panel">
    <div class="map-section">
      <div #mapContainer class="mapbox-container"></div>
      <div class="destination-panel" *ngIf="destinationGroups.length">
        <button type="button" class="fit-selected-btn" (click)="fitSelectedDestinations()">{{ "i18n.domain.deliveryDetails.actions.fit-selected" | translate }}</button>
        <button
          type="button"
          class="destination-chip"
          *ngFor="let group of destinationGroups"
          (click)="toggleDestinationGroup(group)"
        >
          {{ group.orderIds.length }} · {{ group.address }}
        </button>
      </div>

      <button
        class="fullscreen-toggle-btn"
        (click)="toggleMapFullScreen()"
        [attr.title]="
          (isMapFullScreen
            ? 'i18n.domain.deliveryDetails.tooltips.exit-fullscreen'
            : 'i18n.domain.deliveryDetails.tooltips.fullscreen'
          ) | translate
        "
      >
        <i
          [class]="isMapFullScreen ? 'pi pi-times' : 'pi pi-window-maximize'"
        ></i>
      </button>

      <div class="draw-buttons-group">
        <button
          class="draw-btn draw-circle-btn"
          (click)="toggleDrawCircle()"
          [class.active]="isDrawMode && currentDrawMode === 'circle'"
          [disabled]="!selectedDeliveryPlan && !showNewDeliveryForm"
          title="Draw circle to select multiple orders"
        >
          <i
            [class]="
              isDrawMode && currentDrawMode === 'circle'
                ? 'pi pi-times'
                : 'pi pi-circle'
            "
          ></i>
          <span *ngIf="!isMapFullScreen">{{
            isDrawMode && currentDrawMode === "circle" ? "Cancel" : "Circle"
          }}</span>
        </button>

        <button
          class="draw-btn draw-polygon-btn"
          (click)="toggleDrawPolygon()"
          [class.active]="isDrawMode && currentDrawMode === 'polygon'"
          [disabled]="!selectedDeliveryPlan && !showNewDeliveryForm"
          title="Draw polygon to select multiple orders"
        >
          <i
            [class]="
              isDrawMode && currentDrawMode === 'polygon'
                ? 'pi pi-times'
                : 'pi pi-stop'
            "
          ></i>
          <span *ngIf="!isMapFullScreen">{{
            isDrawMode && currentDrawMode === "polygon" ? "Cancel" : "Polygon"
          }}</span>
        </button>
      </div>

      <div class="draw-instructions" *ngIf="isDrawMode">
        <p>
          <strong>{{
            currentDrawMode === "circle"
              ? "Draw Circle Mode"
              : "Draw Polygon Mode"
          }}</strong>
        </p>

        <p class="help-text">
          All orders within the {{ currentDrawMode }} will be added to "{{
            showNewDeliveryForm
              ? newDeliveryPlan.name
              : selectedDeliveryPlan?.name
          }}"
        </p>

        <button class="cancel-draw-btn" (click)="cancelDrawMode()">
          <i class="pi pi-times"></i> Cancel Drawing
        </button>
      </div>

      <div class="map-legend">
        <div class="legend-item">
          <span class="legend-marker pending"></span>
          <span>{{
            "i18n.domain.deliveryDetails.legend.available-for-delivery"
              | translate
          }}</span>
        </div>
        <div class="legend-item">
          <span class="legend-marker assigned"></span>
          <span>{{
            "i18n.domain.deliveryDetails.legend.added-to-plan" | translate
          }}</span>
        </div>
      </div>
    </div>

    <div
      class="delivery-details-form"
      *ngIf="showNewDeliveryForm && !isMapFullScreen"
      [class.minimized]="isFormMinimized"
    >
      <div class="form-header">
        <h3>
          {{
            "i18n.domain.deliveryDetails.dialogs.create-delivery-plan"
              | translate
          }}
        </h3>
        <div class="form-header-actions">
          <button
            class="minimize-btn"
            (click)="toggleMinimizeForm()"
            [title]="isFormMinimized ? 'Expand' : 'Minimize'"
          >
            <i
              [class]="
                isFormMinimized
                  ? 'pi pi-window-maximize'
                  : 'pi pi-window-minimize'
              "
            ></i>
          </button>
          <button
            class="close-btn"
            (click)="cancelNewDeliveryDialog()"
            title="Close"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>

      <div class="form-body" *ngIf="!isFormMinimized">
        <div class="form-row name-assigned-row">
          <div class="form-field">
            <label>
              {{
                "i18n.domain.deliveryDetails.fields.delivery-plan-name"
                  | translate
              }}
              <span class="required-asterisk">*</span>:
            </label>
            <input
              type="text"
              pInputText
              [(ngModel)]="newDeliveryPlan.name"
              placeholder="{{
                'i18n.domain.deliveryDetails.placeholders.delivery-plan-name'
                  | translate
              }}"
              class="form-input"
            />
          </div>

          <div class="form-field">
            <label>
              {{ "i18n.domain.deliveryDetails.fields.assigned" | translate }}
              (Optional):
            </label>
            <p-dropdown
              [options]="applicationUsers"
              [(ngModel)]="newDeliveryPlan.assignedToId"
              optionLabel="displayName"
              optionValue="userId"
              placeholder="{{
                'i18n.domain.deliveryDetails.placeholders.assign-driver'
                  | translate
              }}"
              [showClear]="true"
              appendTo="body"
              [baseZIndex]="10000"
              class="form-dropdown"
              [style]="{ width: '100%' }"
            ></p-dropdown>
          </div>
        </div>

        <div class="form-row date-comments-row">
          <div class="form-field">
            <label>
              {{
                "i18n.domain.deliveryDetails.fields.deliveryDate" | translate
              }}
              (Optional):
            </label>
            <p-calendar
              [(ngModel)]="newDeliveryPlan.deliveryDate"
              [showTime]="true"
              dateFormat="dd/mm/yy"
              [minDate]="today"
              appendTo="body"
              [baseZIndex]="10000"
              [style]="{ width: '100%' }"
            ></p-calendar>
          </div>

          <div class="form-field">
            <label>
              {{ "i18n.domain.deliveryDetails.fields.comments" | translate }}
              (Optional):
            </label>
            <textarea
              pInputTextarea
              [(ngModel)]="newDeliveryPlan.comments"
              rows="1"
              placeholder="{{
                'i18n.domain.deliveryDetails.placeholders.order-comments'
                  | translate
              }}"
              class="form-textarea"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="form-actions" *ngIf="!isFormMinimized">
        <button
          pButton
          label="{{ 'i18n.shared.cancel' | translate }}"
          class="p-button-outlined"
          (click)="cancelNewDeliveryDialog()"
        ></button>

        <button
          pButton
          label="Create Draft"
          class="p-button-primary"
          (click)="createNewDeliveryPlan()"
          [disabled]="!newDeliveryPlan.name?.trim()"
        ></button>
      </div>
    </div>

    <div
      class="delivery-details-form"
      *ngIf="selectedDeliveryPlan && !showNewDeliveryForm && !isMapFullScreen"
      [class.minimized]="isFormMinimized"
    >
      <div class="form-header-with-tabs">
        <div class="header-top">
          <h3>{{ selectedDeliveryPlan.name }}</h3>
          <div class="form-header-actions">
            <button
              class="minimize-btn"
              (click)="toggleMinimizeForm()"
              [title]="isFormMinimized ? 'Expand' : 'Minimize'"
            >
              <i
                [class]="
                  isFormMinimized
                    ? 'pi pi-window-maximize'
                    : 'pi pi-window-minimize'
                "
              ></i>
            </button>
            <button
              class="close-btn"
              (click)="closeDeliveryForm()"
              title="Close"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        </div>

        <div class="header-tabs" *ngIf="!isFormMinimized">
          <button
            class="tab-btn"
            [class.active]="activeTabIndex === 0"
            (click)="activeTabIndex = 0"
          >
            Delivery Information
          </button>
          <button
            class="tab-btn"
            [class.active]="activeTabIndex === 1"
            (click)="activeTabIndex = 1"
          >
            Orders ({{ selectedDeliveryPlan.orderIds.length }})
          </button>
        </div>
      </div>

      <div class="form-body" *ngIf="!isFormMinimized">
        <div class="tab-content" *ngIf="activeTabIndex === 0">
          <div *ngIf="isSelectedPlanReadOnly" class="submitted-plan-notice">
            <i class="pi pi-check-circle"></i>
            This delivery plan has been submitted and is read-only.
          </div>

          <div class="form-row">
            <div class="form-field">
              <label>
                {{ "i18n.domain.deliveryDetails.fields.name" | translate }}:
              </label>

              <input
                *ngIf="!isSelectedPlanReadOnly"
                type="text"
                pInputText
                [(ngModel)]="selectedDeliveryPlan.name"
                class="form-input"
              />
              <div *ngIf="isSelectedPlanReadOnly" class="readonly-value">
                {{ selectedDeliveryPlan.name }}
              </div>
            </div>

            <div class="form-field">
              <label>
                {{ "i18n.domain.deliveryDetails.fields.assigned" | translate }}:
              </label>

              <p-dropdown
                *ngIf="!isSelectedPlanReadOnly"
                [options]="applicationUsers"
                [(ngModel)]="selectedDeliveryPlan.assignedToId"
                optionLabel="displayName"
                optionValue="userId"
                placeholder="{{
                  'i18n.domain.deliveryDetails.placeholders.assign-driver'
                    | translate
                }}"
                [showClear]="true"
                appendTo="body"
                [baseZIndex]="10000"
                class="form-dropdown"
                [style]="{ width: '100%' }"
              ></p-dropdown>
              <div *ngIf="isSelectedPlanReadOnly" class="readonly-value">
                {{ selectedDeliveryPlan.assignedTo || "—" }}
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field">
              <label>
                {{ "i18n.domain.deliveryDetails.fields.status" | translate }}:
              </label>
              <div class="status-badge-wrapper">
                <div
                  class="status-badge"
                  [class.draft]="selectedDeliveryPlan.status === 'draft'"
                  [class.active]="
                    selectedDeliveryPlan.status === 'out-for-delivery'
                  "
                  [class.delivered]="
                    selectedDeliveryPlan.status === 'delivered'
                  "
                >
                  {{
                    selectedDeliveryPlan.status === "draft"
                      ? "Draft"
                      : selectedDeliveryPlan.status === "delivered"
                        ? "Delivered"
                        : "Out for Delivery"
                  }}
                </div>
              </div>
            </div>

            <div class="form-field">
              <label>
                {{ "i18n.domain.deliveryDetails.fields.comments" | translate }}:
              </label>

              <textarea
                *ngIf="!isSelectedPlanReadOnly"
                pInputTextarea
                [(ngModel)]="selectedDeliveryPlan.comments"
                rows="2"
                placeholder="{{
                  'i18n.domain.deliveryDetails.placeholders.order-comments'
                    | translate
                }}"
                class="form-textarea"
              ></textarea>
              <div *ngIf="isSelectedPlanReadOnly" class="readonly-value">
                {{ selectedDeliveryPlan.comments || "—" }}
              </div>
            </div>
          </div>

          <div class="form-row" *ngIf="!isSelectedPlanReadOnly">
            <div class="form-field">
              <label>
                {{
                  "i18n.domain.deliveryDetails.fields.deliveryDate" | translate
                }}
                <span class="required-asterisk" title="Required to submit"
                  >*</span
                >:
              </label>
              <p-calendar
                [(ngModel)]="selectedDeliveryPlan.deliveryDate"
                [showTime]="true"
                dateFormat="dd/mm/yy"
                [minDate]="today"
                appendTo="body"
                [baseZIndex]="10000"
                [style]="{ width: '100%' }"
              ></p-calendar>
            </div>
            <div class="form-field"></div>
          </div>

          <div class="form-row" *ngIf="isSelectedPlanReadOnly">
            <div class="form-field">
              <label>
                {{
                  "i18n.domain.deliveryDetails.fields.deliveryDate" | translate
                }}:
              </label>
              <div class="readonly-value">
                {{ formatDate(selectedDeliveryPlan.deliveryDate) }}
              </div>
            </div>
            <div class="form-field"></div>
          </div>
        </div>

        <div class="tab-content" *ngIf="activeTabIndex === 1">
          <div *ngIf="isSelectedPlanReadOnly" class="submitted-plan-notice">
            <i class="pi pi-lock"></i>
            Orders cannot be added or removed after a plan is submitted.
          </div>

          <div class="form-row" *ngIf="!isSelectedPlanReadOnly">
            <div class="form-field full-width">
              <label>Add Orders:</label>
              <p-dropdown
                [options]="availableOrdersForEditPlan"
                [(ngModel)]="selectedOrderToAdd"
                (onChange)="addOrderToSelectedPlan($event.value)"
                optionLabel="displayText"
                optionValue="id"
                placeholder="Select order to add..."
                [filter]="true"
                filterBy="displayText"
                [showClear]="true"
                appendTo="body"
                [baseZIndex]="10000"
                class="form-dropdown"
                [style]="{ width: '100%' }"
              >
                <ng-template let-order pTemplate="item">
                  <div class="order-dropdown-item">
                    <div class="order-number">{{ order.orderNumber }}</div>
                    <div class="order-details">
                      {{ order.buyerName }} - {{ order.buyerAddress }}
                    </div>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field full-width">
              <label>
                Selected Orders ({{ selectedDeliveryPlan.orderIds.length }}):
              </label>

              <div class="orders-in-plan-list">
                <div
                  *ngFor="let order of getOrdersInPlan(selectedDeliveryPlan)"
                  class="order-list-item"
                >
                  <div class="order-item-info">
                    <div class="order-item-number">{{ order.orderNumber }}</div>
                    <div class="order-item-details">
                      {{ order.buyerName }} • {{ order.buyerAddress }}
                    </div>
                  </div>

                  <button
                    *ngIf="!isSelectedPlanReadOnly"
                    class="remove-order-btn"
                    (click)="removeOrderFromDelivery(order.id!)"
                    title="Remove order"
                  >
                    <i class="pi pi-times"></i>
                  </button>
                </div>

                <div
                  *ngIf="selectedDeliveryPlan.orderIds.length === 0"
                  class="no-orders-message"
                >
                  <i class="pi pi-inbox"></i>
                  <p>
                    {{
                      "i18n.domain.deliveryDetails.messages.no-orders-added"
                        | translate
                    }}
                  </p>
                  <small
                    >Use the dropdown above, map drawing tools, or right-click
                    markers to add orders</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="form-actions"
        *ngIf="!isFormMinimized && !isSelectedPlanReadOnly"
      >
        <button
          pButton
          label="{{
            'i18n.domain.deliveryDetails.actions.save-draft' | translate
          }}"
          class="p-button-outlined"
          (click)="saveDraft()"
        ></button>

        <button
          pButton
          label="{{ 'i18n.domain.deliveryDetails.actions.submit' | translate }}"
          class="p-button-primary"
          (click)="submitDelivery()"
          [disabled]="
            selectedDeliveryPlan.orderIds.length === 0 ||
            !selectedDeliveryPlan.assignedToId ||
            !selectedDeliveryPlan.deliveryDate
          "
        ></button>

        <button
          pButton
          label="Delete"
          class="p-button-danger"
          (click)="deleteDeliveryPlan()"
        ></button>
      </div>

      <div
        class="form-actions"
        *ngIf="!isFormMinimized && isSelectedPlanReadOnly"
      >
        <button
          pButton
          label="Close"
          class="p-button-outlined"
          (click)="closeDeliveryForm()"
        ></button>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showOrderDetailsDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '450px' }"
  header="{{ 'i18n.domain.deliveryDetails.dialogs.order-details' | translate }}"
>
  <div *ngIf="selectedOrder" class="order-details-dialog">
    <div class="detail-row">
      <span class="label">
        {{ "i18n.domain.deliveryDetails.fields.order-number" | translate }}:
      </span>
      <span class="value">{{ selectedOrder.orderNumber }}</span>
    </div>
    <div class="detail-row">
      <span class="label">
        {{ "i18n.domain.deliveryDetails.fields.customer" | translate }}:
      </span>
      <span class="value">{{ selectedOrder.buyerName }}</span>
    </div>
    <div class="detail-row">
      <span class="label">
        {{ "i18n.domain.deliveryDetails.fields.address" | translate }}:
      </span>
      <span class="value">{{ selectedOrder.buyerAddress }}</span>
    </div>
    <div class="detail-row">
      <span class="label">
        {{ "i18n.domain.deliveryDetails.fields.order-date" | translate }}:
      </span>
      <span class="value">{{ formatDate(selectedOrder.orderDate) }}</span>
    </div>
    <div class="detail-row">
      <span class="label">
        {{ "i18n.domain.deliveryDetails.fields.status" | translate }}:
      </span>
      <span class="value status-badge">{{ selectedOrder.status }}</span>
    </div>
    <div class="detail-row" *ngIf="selectedOrder.contactNumber">
      <span class="label">
        {{ "i18n.domain.deliveryDetails.fields.contact" | translate }}:
      </span>
      <span class="value">{{ selectedOrder.contactNumber }}</span>
    </div>
    <div class="detail-row" *ngIf="selectedOrder.deliveryInstructions">
      <span class="label">
        {{ "i18n.domain.deliveryDetails.fields.instructions" | translate }}:
      </span>
      <span class="value">{{ selectedOrder.deliveryInstructions }}</span>
    </div>
  </div>
</p-dialog>
